import React from 'react'
import { Customizations } from 'models'
import VehicleSheetLinesGroup from '../VehicleSheetLinesGroup'

const VehicleSheetSectionCharacteristics = () => {
  const characteristicItems: (keyof Customizations)[] = [
    'make',
    'version',
    'bodyTypeRegDoc',
    'typeRegDoc',
    'dateFirstReg',
    'fuelType',
    'color',
    'numberOfSeats',
    'taxHp',
    'typeSpare',
    'providedMileage',
  ]

  return (
    <VehicleSheetLinesGroup
      arrayOfKeys={characteristicItems}
      className="vehicle-sheet__characteristic-items"
    />
  )
}

export default VehicleSheetSectionCharacteristics
